import ManageDatabaseSystems from '@/components/ManageDatabase/ManageDatabaseSystems.vue';

export default {
  components: { ManageDatabaseSystems },
};
